import axios from "axios";
import { compress } from "../helpers/common.helper";
const apiUri = import.meta.env.GATEWAY_URI;

export default function usePayments() {
  const createInvoice = async ({ commission, quotation }) => {
    const _body = compress(JSON.stringify({ quotation, commission }));

    const result = await axios.post(`${apiUri}/api/v1/payments`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data?.data;
  };

  const queryPayments = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (sort) reqBody.sort = sort;
    if (project) reqBody.project = project;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(`${apiUri}/api/v1/payments/query`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const getPayment = async (id) => {
    const result = await axios.get(`${apiUri}/api/v1/payments/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return result.data?.data;
  };

  // TODO: Patch invoice to flag paid
  // const getInvoice = async (id) => {
  //   const result = await axios.get(`${apiUri}/api/v1/payments/${id}`, {
  //     headers: {
  //       Authorization: `Bearer ${localStorage.getItem("token")}`,
  //     },
  //   });
  //   return result.data?.data;
  // };

  const createPayment = async (body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(`${apiUri}/api/v1/payments`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const chargePayment = async (paymentId, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(
      `${apiUri}/api/v1/payments/${paymentId}/charge`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  return {
    createPayment,
    queryPayments,
    chargePayment,
  };
}
